import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { APP_SETTINGS } from '@services';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class RoleAuthGuard  {

  constructor(public auth: AuthService, public router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const userInfo = APP_SETTINGS;
        const userType = userInfo['isAuthorized'];
        if (!userType) {
          this.router.navigate(['home']);
          return false;
        }
        return true;
  }
}
